import { render } from "./MyDevicesPage.vue?vue&type=template&id=1c3c7a82"
import script from "./MyDevicesPage.vue?vue&type=script&lang=js"
export * from "./MyDevicesPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__